module.exports = __webpack_public_path__ + "static/media/checkbox_select.b171429f.svg";